export * from './IconMoneyCash';
export { default as IconMoneyCash } from './IconMoneyCash';
